module.exports = __webpack_public_path__ + "images/people/woman-with-card@2x-f948a3885146f1b4d192fb1655d4b6a3.webp";